export const itemsOrder  = [
    { value: '{"alumno.apellido1": "ASC", "alumno.apellido2": "ASC", "alumno.nombre": "ASC"}', label: "Apellidos, Nombre" }
]